import React from 'react';
import { supabase } from '../utils/supabaseClient';
import '../components/LoginModal.css'; // Reusing styles for the button

const AuthPopup = () => {
    const handleGoogleLogin = async () => {
        const { error } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: `${window.location.origin}/auth/callback`,
                skipBrowserRedirect: false
            }
        });

        if (error) {
            console.error('Error starting OAuth:', error);
            alert('Error starting login: ' + error.message);
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            padding: '40px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: '#f9fafb',
            color: '#1f2937'
        }}>
            {/* Logo Area */}
            <div style={{ marginBottom: '24px', textAlign: 'center' }}>
                <h1 style={{
                    fontSize: '32px',
                    fontWeight: '800',
                    color: '#006aff',
                    margin: '0 0 8px 0',
                    letterSpacing: '-0.5px'
                }}>
                    Revest AI
                </h1>
                <p style={{
                    fontSize: '16px',
                    color: '#6b7280',
                    margin: '0',
                    fontWeight: '500'
                }}>
                    Find Deals in seconds.
                </p>
            </div>

            {/* Main Card */}
            <div style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                width: '100%',
                maxWidth: '360px',
                textAlign: 'center'
            }}>
                <h2 style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    marginBottom: '8px',
                    marginTop: '0'
                }}>
                    Welcome Back
                </h2>
                <p style={{
                    fontSize: '14px',
                    color: '#6b7280',
                    marginBottom: '32px',
                    lineHeight: '1.5'
                }}>
                    Sign in to save searches and track your favorite properties.
                </p>

                <button
                    onClick={handleGoogleLogin}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: 'white',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '15px',
                        fontWeight: '500',
                        color: '#374151',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        gap: '12px'
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#f9fafb';
                        e.currentTarget.style.borderColor = '#d1d5db';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.borderColor = '#e5e7eb';
                    }}
                >
                    <img
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                        alt="Google logo"
                        style={{ width: '20px', height: '20px' }}
                    />
                    <span>Continue with Google</span>
                </button>
            </div>

            <p style={{
                marginTop: '32px',
                fontSize: '12px',
                color: '#9ca3af'
            }}>
                Secured by Supabase
            </p>
        </div>
    );
};

export default AuthPopup;
